import React, { useState, useEffect } from 'react';
import Select from 'react-select';

import styles from './MultiSelect.module.css';

const customStyles = {
  control: (base) => ({
    ...base,
    minHeight: '48px',
    fontSize: '16px',
    fontFamily: 'MuseoSansCyrl',
    fontWeight: 'bold',
    borderColor: '#ccc',
    boxShadow: 'none',
    '&:hover': {
      border: '1px solid #ccc',
    },
  }),
  placeholder: (base) => ({
    ...base,
    color: '#5F5F5F',
    fontSize: '16px',
    fontFamily: 'MuseoSansCyrl',
    fontWeight: 'bold',
  }),
  option: (base, { isFocused, isSelected }) => ({
    ...base,
    backgroundColor: isSelected ? '#4CAF50' : isFocused ? '#E3F2FD' : 'white',
    fontSize: '14px',
    fontFamily: 'MuseoSansCyrl',
    fontWeight: 'bold',
    color: '#393633',
    padding: '8px 12px',
    cursor: 'pointer',
  }),
  valueContainer: (base) => ({
    ...base,
    paddingLeft: '6px',
  }),
  multiValue: (base) => ({
    ...base,
    height: '30px',
    borderRadius: '15px',
    lineHeight: '30px',
    padding: '0',
    fontFamily: 'MuseoSansCyrl',
    overflow: 'hidden',
  }),
  multiValueLabel: (base) => ({
    ...base,
    padding: '0 2px 0 12px !important',
    color: '#2E7334', 
    fontSize: '16px',
    fontWeight: 'bold',
    fontFamily: 'MuseoSansCyrl',
    backgroundColor: '#E8F5E2',
  }),
  multiValueRemove: (base) => ({
    ...base,
    backgroundColor: '#E8F5E2',
    color: '#2E7334',
    padding: '0 5px 0 2px',
    fontSize: '30px',
    svg: {
      width: 20,
      height: 20,
      cursor: 'pointer',
    },
    '&:hover': {
      backgroundColor: '#E8F5E2',
      svg: {
        fill: '#2E7334',
      }
    },
  }),
};

const MultiSelect = (props) => {
  const {
    onChange,
    options,
    placeholder,
    initialValue = [],
  } = props;

  const [value, setValue] = useState([]);

  useEffect(() => {
    if (initialValue.length) {
      setValue(initialValue);
    }
  }, []);

  const onChangeHandler = (newValue) => {
    setValue(newValue);
    onChange(newValue);
  };

  return (
    <div className={styles.wrapper}>
      <div className={styles.selectWrapper}>
        <Select 
          placeholder={placeholder}
          options={options} 
          onChange={onChangeHandler}
          getOptionLabel={(option) => option.name}
          getOptionValue={(option) => option.id}
          value={value}
          styles={customStyles}
          isSearchable
          isMulti
        />
      </div>
    </div>
  );
};

export default MultiSelect;
